
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-478.9 128 50.3 49.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M-438.4 155.8c-.7-3.1-1.7-4.8-2.7-5-.8-.1-1.5.7-2.1 2.5v.2c-.2 1.5-1.9 11.6-3 13.5-1.4 1.9-12.1 7.1-12.1 7.1-3.6 2.5-1.8 4.3 3.8 3.7 0 0 8.5-.8 13.5-4 .8-.5 1.5-1.1 1.9-1.7 2.4-2.8 1.7-11.7.7-16.3"}}),_c('path',{attrs:{"d":"M-429.3 147.4c-.2-.9-.6-1.8-1-2.4-2-3.2-10.7-5.2-15.4-5.7-3.1-.3-5.1.1-5.5 1-.4.7.2 1.7 1.7 2.8 0 0 .1 0 .2.1 1.4.7 10.5 5.4 11.9 7 1.4 1.9 3 13.7 3 13.7 1.3 4.2 3.5 3 4.7-2.4.1 0 2-8.4.4-14.1"}}),_c('path',{attrs:{"d":"M-437.4 132.3s-7.5-4.2-13.4-4.3c-1 0-1.9 0-2.5.3-3.6 1-8 8.8-9.8 13.2-1.3 3.2-1.3 5.3-.3 5.8.6.3 1.6-.1 2.9-1.1 0 0 .1-.1.1-.2 1.1-1.2 8.1-8.5 10.1-9.5 2.2-.8 14 1 14 1 4.3-.1 3.8-2.6-1.1-5.2"}}),_c('path',{attrs:{"d":"M-467.7 145.2c0-2.4 5.9-12.8 5.9-12.8 1.5-4.1-1-4.5-5.3-.9 0 0-6.6 5.5-8.7 11-.4.9-.6 1.8-.6 2.5-.4 3.8 5.4 10.6 8.8 13.9 2.6 2.4 4.5 3.1 5.3 2.4.5-.5.5-1.5 0-3.1 0 0 0-.1-.1-.2-.7-1.3-5.1-10.6-5.3-12.8z"}}),_c('path',{attrs:{"d":"M-448 163.4c-.3-.6-1.3-.9-2.9-.9h-.2c-1.5.2-11.7 1.8-13.8 1.3-2.3-.7-10.5-9.3-10.5-9.3-3.5-2.6-4.6-.4-2.4 4.8 0 0 3.4 7.9 8 11.6.8.6 1.5 1.1 2.2 1.3 3.5 1.4 11.7-2 15.8-4.4 3-1.8 4.3-3.4 3.8-4.4"}})])])
          )
        }
      }
    